import { Component, Vue, Mixins, Watch } from 'vue-property-decorator';
import { AllComponents } from '@/components/AllComponents';
import CommonView from '@/views/CommonView';
import BASEAPI from '@/util/BASEAPI';
import { AxiosErrorHandler, isAxiosError } from '@/util/AxiosErrorHandler';
import { ProductPrizeGroupCategoryEnum, RedirectPaymentMethodEnum } from '@/generated/api';
import { creditEdit } from '@/util/Form';

@Component({
    components: AllComponents(),
})
export default class Movie extends Mixins(CommonView) {
    kurukuru: boolean = false;
    public error: string = "";
    public callback: boolean = false;

    public orderHistory: BASEAPI.OrderHistory | null = null;
    public normalPrizeList:  BASEAPI.Prize[] = [];
    public wChancePrizeList:  BASEAPI.Prize[] = [];
    public bonusPrizeList:  BASEAPI.Prize[] = [];
    public orderID: string = "";
    public inSale: boolean = false;
    public now: number = 0;
    public startAt: number = 0;
    public endAt: number = 0;
    public newCardFlag: boolean = false;
    public paymentMethod: RedirectPaymentMethodEnum = RedirectPaymentMethodEnum.CARD;

    public url: string = "https://oshi-challe.jp";
    public shareText: string = "";

    public async created() {
        await this.init();

    }

    @Watch('$route')
    public async init() {
        this.kurukuru = true;
        if (await this.isLoginRedirect(true)) return;

        let directoryName = this.$route.params.directoryName;
        if(!directoryName){
            this.$router.push("/");
            return;
        }

        let query = this.$route.query;
        if (query) {
            if (this.$route.query.orderID && typeof this.$route.query.orderID === "string") {
                this.orderID = this.$route.query.orderID
            }
            if (this.$route.query.newCardFlag && typeof this.$route.query.newCardFlag === "string") {
                this.newCardFlag = this.$route.query.newCardFlag === "true" ? true : false
            }
            if(query.callback == "true"){
                this.callback = true;
                this.kurukuru = false;
                return;
            }
        }

        if(!this.orderID){
            this.$router.push("/");
            return;
        }

        let id = Number(this.orderID.substring(this.orderID.indexOf('H') + 1));
        let resOrder = await BASEAPI.OrderHistoryController.getOrderHistoryUsingGET(id).catch(AxiosErrorHandler);
        if (isAxiosError(resOrder)) {
            this.error = "" + resOrder.data;
            this.kurukuru = false;
            return;
        }
        this.orderHistory = resOrder.data;

        this.orderHistory.orderHistoryPrizeList?.forEach(item => {
            for(let i = 0; i < item.count; i++){
                if(item.prize.prizeGroup?.category == "normal"){
                    this.normalPrizeList.push(item.prize);
                }
                if(item.prize.prizeGroup?.category == "w_chance"){
                    this.wChancePrizeList.push(item.prize);
                }
                if(item.prize.prizeGroup?.category == "bonus"){
                    this.bonusPrizeList.push(item.prize);
                }
            }
        });

        // 販売チェック
        this.inSale = true;
        this.now = new Date().getTime();
        this.startAt = new Date(this.orderHistory.product.saleStartedAt!).getTime();
        this.endAt = new Date(this.orderHistory.product.saleEndedAt!).getTime();
        if(this.orderHistory.product.inSale === false){
            this.inSale = false;
        }
        if(this.startAt > this.now){
            this.inSale = false;
        }

        if(this.endAt < this.now){
            this.inSale = false;
        }

        this.shareText = "【推しちゃれ】" + this.orderHistory.product.title + "を引いたよ！";
        this.url = "https://oshi-challe.jp/product/" + this.orderHistory.product.directoryName;
        this.kurukuru = false;
    }

    public async check(){
        // ログインしていない場合
        if (await this.isLoginRedirect(true)) {
            return
        } else {
            this.$router.push("/product/" + this.orderHistory!.product.directoryName + "/shopping");
        }
    }

    public async postCard() {
        const url = "/product/" + this.orderHistory?.product.directoryName + "/resultall?orderID=" + this.orderID ;
        let redirectRes = await BASEAPI.RedirectController.addRedirectUsingPOST({ url: url, paymentMethod: this.paymentMethod }).catch(AxiosErrorHandler);
        if (isAxiosError(redirectRes)) {
            this.error = "" + redirectRes.data;
            return;
        }
        try {
            let res = await creditEdit("/api/credit/callBack?id=" + redirectRes.data.id, "/product/" + this.orderHistory?.product.directoryName + "/resultall?orderID=" + this.orderID, "", this.orderID);
        } catch (error) {
            this.error = "" + error;
            return;
        }
    }
}
